export const QUEUE_NOTIFICATION = '@notifications/queue-notification';
export const UPDATE_NOTIFICATION = '@notifications/update-notification';
export const CLEAR_ALL_NOTIFICATIONS = '@notifications/clear-all-notification';
export const SET_NOTIFICATION_SETTINGS =
  '@notifications/set-notification-settings';
export const CLEAR_ONE_NOTIFICATION = '@notifications/clear-one-notification';

/*
  Notification shape
  {
    to: '', //Leave to blank to send to all users
    from: '',
    read: false,
    text: '',
    //Relative link
    pageLink: '' ,
    severity: ['info' | 'warning' | 'error' | 'success']
  }  
 */

const DEFAULT_STATE = {
  messages: [],
  pulseAnimation: false,
  displayNumberedBadge: true,
};

export const clearAllNotifications = () => ({
  type: CLEAR_ALL_NOTIFICATIONS,
  payload: { ...DEFAULT_STATE },
});

export const clearOneNotification = (docId) => ({
  type: CLEAR_ONE_NOTIFICATION,
  payload: { docId },
});

export const setNotificationSettings = (settingsObject = DEFAULT_STATE) => ({
  type: SET_NOTIFICATION_SETTINGS,
  payload: { ...settingsObject },
});


export const queueNotification = (messages) => ({
  type: QUEUE_NOTIFICATION,
  payload: { messages },
});
